import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ProfileService } from '../../../services/profile.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';

@Component({
  selector: 'app-profile-edit',
  templateUrl: './profile-edit.component.html',
  styleUrls: ['./profile-edit.component.scss']
})
export class ProfileEditComponent implements OnInit {

    pagecode: string = "profile-edit";
    module: string = "profile";
    accessdenied: boolean = false;

    myControl = new FormControl();
    mobileLoginForm = new FormGroup({
        phone: new FormControl("", [Validators.required])
    });



    nationalityList: any[] = this.common.nationalities;
    filteredNationality: any[] = [];
    selectedNationality: any;


    filterNationality(event: any) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < this.nationalityList.length; i++) {
            let nat = this.nationalityList[i];
            if (nat.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(nat);
            }
        }

        this.filteredNationality = filtered;
    }

    countryOfResidenceList: any[] = this.common.countries;
    filteredCountry: any[] = [];
    selectedCountry: any;

    filterCountry(event: any) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < this.countryOfResidenceList.length; i++) {
            let cou = this.countryOfResidenceList[i];
            if (cou.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(cou);
            }
        }

        this.filteredCountry = filtered;
    }

    genderChangeValue(evt: any) {
        var value = evt.target.value;
        this.userData.gender = value;
    }

    isLinear = false;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    constructor(private _formBuilder: FormBuilder, private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) {


        this.firstFormGroup = this._formBuilder.group({
            firstCtrl: ['', Validators.required],
        });
        this.secondFormGroup = this._formBuilder.group({
            secondCtrl: ['', Validators.required],
        });
        this.privacy = _formBuilder.group({
            allowSearch: false,
            allowEmailAddress: false,
            allowMobileNumber: false,
            allowSocialMediaLinks: false
        });
    }
    userData: any = this.authentication.userData;
    openRequest() {
        this.router.navigate(['/request/profilesubmit']);

    }
    privacy: FormGroup;
    ngOnInit(): void {

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        if (this.userData.nationality) {
                            for (var i = 0; i < this.nationalityList.length; i++) {
                                this.nationalityList[i].selected = false;
                                if (this.nationalityList[i].name.toLowerCase() === this.userData.nationality.toLowerCase()) {
                                    this.selectedNationality = this.nationalityList[i];
                                    this.nationalityList[i].selected = true;
                                }
                            }
                        }
                        debugger;
                        if (this.userData.country) {
                            for (var i = 0; i < this.countryOfResidenceList.length; i++) {
                                this.countryOfResidenceList[i].selected = false;
                                if (this.countryOfResidenceList[i].name.toLowerCase() === this.userData.country.toLowerCase()) {
                                    this.selectedCountry = this.countryOfResidenceList[i];
                                    this.countryOfResidenceList[i].selected = true;
                                }
                            }
                        }

                        if (this.userData.mobilePhone) {
                            this.mobileLoginForm.setValue({ "phone": this.userData.mobilePhone });
                        }

                        this.privacy.setValue(
                            {
                                allowSearch: this.userData.allowSearch,
                                allowEmailAddress: this.userData.allowEmailAddress,
                                allowMobileNumber: this.userData.allowMobileNumber,
                                allowSocialMediaLinks: this.userData.allowSocialMediaLinks
                            }
                        );

                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });




    }

    imageChangedEvent: any = '';
    croppedImage: any = this.userData.contactLogo_m;

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
    }
    imageLoaded() {
        // show cropper
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        // show message
    }

    save() {
        if (this.formValidation()) {

            this.profileService.updateMyProfile(this.userData).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.userData = res.data;
                        this.authentication.userData = res.data;
                        this.router.navigate(['/profile/myprofile']);
                    }
                    else {
                        console.error("error", res.error_message);
                        this.common.ShowMessage('error', res.error_message, '');
                    }
                },
                (err: any) => {
                    console.error("error", err);
                    this.common.ShowMessage('error', 'Failed to update your profile, please try again later', '');
                }
            );


            //console.log("phonenumber", this.phoneForm.value.phone);
            //console.log("updated profile data ", this.userData);
            this.common.ShowMessage('info', 'You have successfully updated your profile', '');
        }
    }
    formValidation() {

        if (this.userData.firstName === '' || this.userData.lastName === '') {
            this.common.ShowMessage('error', 'First name and last name are mandatory', '');
            return false;
        }
        else if (this.mobileLoginForm.value.phone == null) {
            this.common.ShowMessage('error', 'Mobile number is mandatory', '');
            return false;
        }
        else if (this.selectedCountry.name === '' || this.selectedNationality.name === '') {
            this.common.ShowMessage('error', 'Nationality and country of residence are mandatory', '');
            return false;
        }
        else if (this.userData.title === '') {
            this.common.ShowMessage('error', 'Job title is mandatory', '');
            return false;
        }

        this.userData.mobilePhone = this.mobileLoginForm.value.phone;
        this.userData.mobileCountryCode = "";
        this.userData.nationality = this.selectedNationality.name;
        this.userData.country = this.selectedCountry.name;

        this.userData.allowSearch = this.privacy.value.allowSearch;
        this.userData.allowEmailAddress = this.privacy.value.allowEmailAddress;
        this.userData.allowMobileNumber = this.privacy.value.allowMobileNumber;
        this.userData.allowSocialMediaLinks = this.privacy.value.allowSocialMediaLinks;

        return true;
    }
}
